import React, { useRef} from "react";
import { IonGrid, IonRow, IonCol, IonButton, IonModal, IonInput, IonLabel } from '@ionic/react';


export function UpdatePayMethod_CheckingModal (props) {

    let bankAccountName = useRef();
    let bankAccountNumber = useRef();
    let routingNumber = useRef();
    let bankName = useRef();
    let branchName = useRef();

    function handleSavePaymentMethod_checking() {

        const requestOptions = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
             },
            body: JSON.stringify({
                Tracker: props.tracker,
                user: props.acctID,
                //merchantSchema: schema,
                uEnterBankAcctName: bankAccountName.current.value,
                uEnterAcctNumber: bankAccountNumber.current.value,
                uEnterRoutingNumber: routingNumber.current.value,
                uEnterBankName: bankName.current.value,
                uEnterBankBranch: branchName.current.value,

            })
        }

        fetch("https://ghanaverified.com/hotel_merchantAcct_argsjqApp",requestOptions)
        .then(res => res.text())
        .then(res => {
            
            alert("Payment Method - Checking Updated.");
            alert(res);

       })
    }

    function closeModalHandler(event) {

        //alert('Inside closeModalHandler');
        props.closeModal(event);
    }

    return (
                <IonModal isOpen={ props.openModal }>
                    <IonGrid >
                    <IonRow>
                            <IonCol>
                                <IonLabel>Account Name: </IonLabel>
                                <IonInput placeholder='Enter Bank Account Name' ref={bankAccountName }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Account Number: </IonLabel>
                                <IonInput placeholder='Enter Bank Account Number (17 characters max)' maxlength='17' ref={bankAccountNumber }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Routing Number: </IonLabel>
                                <IonInput placeholder='Enter Bank Routing Number (9 characters exact)' maxlength='9' ref={routingNumber }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Bank Name: </IonLabel>
                                <IonInput placeholder='Enter Bank Name' ref={bankName }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Branch Name: </IonLabel>
                                <IonInput placeholder='Enter Bank Branch Name' ref={branchName }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={() => handleSavePaymentMethod_checking()}> Save </IonButton>
                            </IonCol>
                            <IonCol>
                                <IonButton onClick={() => closeModalHandler(false)}> Cancel </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonModal>
    )
}